import { ReactNode } from 'react';
import { IValidation } from 'src/types/main';

export const InputType = {
  TEXT: 'text',
  NUMBER: 'number',
  FLOAT_NUMBER: 'floatNumber',
  PASSWORD: 'password',
} as const;
export type TInputType = TValueOf<typeof InputType>;

export interface IInputProps extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  type?: TInputType;
  onChangeValue: (value: string | undefined) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  //
  prevComponent?: ReactNode;
  nextComponent?: ReactNode;
  //
  validation?: IValidation;
  // TODO
  // allowNegative?: boolean;
  resetIcon?: boolean;
  loading?: boolean;
  movablePlaceholder?: boolean;
  required?: boolean;
  disableOnFocusOnInputWrapper?: boolean;
  disableRemoveUnnecessaryZeros?: boolean;
  className?: string;
  contentClassName?: string;
  inputClassName?: string;
}

type TOnChangeInputValueHandlerProps = Pick<IInputProps, 'disableRemoveUnnecessaryZeros' | 'type' | 'onChangeValue' | 'maxLength'>;
export interface IOnChangeInputValueHandlerProps extends TOnChangeInputValueHandlerProps {
  isNumberType: boolean;
  event: React.ChangeEvent<HTMLInputElement>;
}
